import React from 'react';
import { useDispatch } from 'react-redux';
import Ratings from '../../../Ratings';
import Quality from '../../../Quality';
import Reports from '../../../Reports';
import { ReputationOperations } from '../../../../ducks/reputation';
import { Container } from './styles';

const Reputation = ({ device }) => {
  const dispatch = useDispatch();
  const { getRatings, getReports, getQuality } = ReputationOperations;

  const reloadDispatch = () => {
    dispatch(getRatings());
    dispatch(getReports());
    dispatch(getQuality());
  };

  return (
    <Container device={device}>
      <Ratings device={device} reloadDispatch={reloadDispatch} />
      <Quality device={device} reloadDispatch={reloadDispatch} />
      <Reports device={device} reloadDispatch={reloadDispatch} />
    </Container>
  );
};

export default Reputation;
